import * as React from 'react';

import { TableCell, TableRow } from 'components/table';
import Entity from 'components/entity/Entity';
import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import EntityName from 'components/entity/entity-name/EntityName';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { getEntityFromUser } from 'utils/view';
import { t } from 'utils/language';

import './team-member.scss';

import type { User } from 'types';

type Props = {
  isRemovable: boolean,
  member: User,
  handleRemove: (member: User) => void
};

class TeamMembers extends React.PureComponent<Props> {
  render() {
    const { member, isRemovable, handleRemove } = this.props;
    const entity = getEntityFromUser(member);

    return (
      <TableRow className="team-member__table-row">
        <TableCell
          width="medium"
        >
          <Entity>
            <EntityAvatar
              bordered
              entity={entity}
            />
            <EntityName
              entity={entity}
            />
          </Entity>
        </TableCell>
        <TableCell className="team-member__email_column">
          <div
            key={member.id}
            title={member.email}
            className="text-overflow-ellipsis"
          >
            {member.email}
          </div>
        </TableCell>
        <TableCell
          width="fill"
          align="right"
        >
          {
            isRemovable &&
              <ActionButton
                color="tertiary"
                width="minimum"
                onClick={() => handleRemove(member)}
                data={{ qa: 'team-members__button-remove' }}
              >
                {t('remove_team_member_button')}
              </ActionButton>
          }
        </TableCell>
      </TableRow>
    );
  }
}

export default TeamMembers;
